import {
  FormCondition,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client'
import { AgxBodyCorporateRecord } from '@urbanx/agx.ui-components2'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import { useEffect } from 'react'
import {
  BODY_CORPORATE_RECORDS_STEP_NAME,
  isBodyCorporateRecordComplete,
} from './ContractComplianceHelper'

const EMPTY_SPECIAL_CONDITIONS: SpecialConditionData[] = []

interface ContractComplianceBodyCorporateRecordProps
  extends TaskModalPageProps {
  bodyCorporateRecordsCondition?: FormCondition
  specialConditions?: SpecialConditionData[]
  onBodyCorporateRecordsValidationErrorChange?: (
    hasValidationError: boolean
  ) => void
  onBodyCorporateRecordsConditionUpdated?: (
    bodyCorporateRecordsCondition: FormCondition | undefined
  ) => void
}

const ContractComplianceBodyCorporateRecord = ({
  bodyCorporateRecordsCondition,
  campaign,
  onBodyCorporateRecordsValidationErrorChange,
  onBodyCorporateRecordsConditionUpdated,
  specialConditions,
  task,
  toggleTaskStep,
}: ContractComplianceBodyCorporateRecordProps) => {
  const BODY_CORPORATE_RECORDS_LABEL = 'Body Corporate Records'
  const step = task.taskSteps?.find(
    (taskStep) => taskStep.name === BODY_CORPORATE_RECORDS_STEP_NAME
  )
  const resolvedSpecialConditions =
    specialConditions ?? EMPTY_SPECIAL_CONDITIONS

  const isValid = isBodyCorporateRecordComplete(bodyCorporateRecordsCondition)

  useEffect(() => {
    if (!step?.order) return

    if ((step.isCompleted ?? false) !== isValid) {
      toggleTaskStep(step.order, isValid)
    }
  }, [isValid, step?.isCompleted, step?.order, toggleTaskStep])

  return (
    <AgxBodyCorporateRecord
      id="contract-compliance-body-corporate-records"
      label={BODY_CORPORATE_RECORDS_LABEL}
      defaultValue={bodyCorporateRecordsCondition}
      validate
      campaignId={campaign.campaignId ?? ''}
      specialConditions={resolvedSpecialConditions}
      defaultToNotApplicable
      onIsValidChange={(isValid) => {
        onBodyCorporateRecordsValidationErrorChange?.(
          Boolean(bodyCorporateRecordsCondition?.condition) && !isValid
        )
      }}
      onValueChanged={({ value }) => {
        onBodyCorporateRecordsConditionUpdated?.(value)
      }}
    />
  )
}

export default ContractComplianceBodyCorporateRecord
